import { render, staticRenderFns } from "./typography-title-wrap.vue?vue&type=template&id=7513a446&scoped=true&"
import script from "./typography-title-wrap.vue?vue&type=script&lang=js&"
export * from "./typography-title-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7513a446",
  null
  
)

export default component.exports